module.exports = __webpack_public_path__ + "static/media/Icon3.681120d9.png";